"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressEligibilityReason = void 0;
/**
 * Reasons returned by the partner check-address-eligibility endpoint. Values are stable and
 * referenced by external partners; keep them snake_case.
 */
var AddressEligibilityReason;
(function (AddressEligibilityReason) {
    AddressEligibilityReason["SUPPORTED"] = "supported";
    AddressEligibilityReason["UNSUPPORTED_STATE"] = "unsupported_state";
    AddressEligibilityReason["UNSUPPORTED_COUNTY"] = "unsupported_county";
    AddressEligibilityReason["INVALID_ADDRESS"] = "invalid_address";
    AddressEligibilityReason["MISSING_UNIT_NUMBER"] = "missing_unit_number";
})(AddressEligibilityReason || (exports.AddressEligibilityReason = AddressEligibilityReason = {}));
